import React from 'react'
import { Card, CardBody, CardHeader, CardTitle, Button } from 'reactstrap'

interface StripeIntegrationProps {
  onSyncWithStripe: () => Promise<void>
  isSyncing: boolean
}

const StripeIntegration: React.FC<StripeIntegrationProps> = ({
  onSyncWithStripe,
  isSyncing,
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="h5 mb-0">Stripe Integration</CardTitle>
      </CardHeader>
      <CardBody>
        {isSyncing ? (
          <Button color="dark" disabled>
            <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
            Synchronizing...
          </Button>
        ) : (
          <Button color="primary" onClick={onSyncWithStripe}>
            <i className="fab fa-stripe font-size-16 align-middle me-2"></i>
            Sync with Stripe
          </Button>
        )}
      </CardBody>
    </Card>
  )
}

export default StripeIntegration
